import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './PaymentCreateScreen';
import PaymentCreate from './PaymentCreateScreen';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getStudentsSmall } from 'src/store/actions/student-actions';
import { getDistrictsSmall } from 'src/store/actions/district-actions';
import { getVendorsSmall } from 'src/store/actions/vendor-actions';
import { getServiceTypes } from 'src/store/actions/service-type-actions';
import { getInvoices } from 'src/store/actions/invoice-actions';
import { getFormValues } from 'redux-form';
import { caseNumbers } from 'src/store/actions/case-actions';
import { selectNameStudents } from '../../../../../../store/selectors/students-selectors';
import { selectNameDistricts } from '../../../../../../store/selectors/districts-selectors';
import { selectNameVendors } from '../../../../../../store/selectors/vendors-selectors';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';
import { getProvidersSmall } from 'src/store/actions/provider-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        students: selectNameStudents(state),
        providers: selectNameProviders(state),
        districts: selectNameDistricts(state),
        vendors: selectNameVendors(state),
        invoices: state.invoices.data,

        caseNumbers: state.cases.caseNumbers,
        serviceTypes: state.serviceTypes.data,
        valuesForm: getFormValues('payment-form')(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getStudents: (params: QueryParams) => dispatch(getStudentsSmall(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
        getDistricts: (params: QueryParams) => dispatch(getDistrictsSmall(params)),
        getVendors: (params: QueryParams) => dispatch(getVendorsSmall(params)),
        getInvoices: (params: QueryParams) => dispatch(getInvoices({ ...params, notTotal: true })),
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
        getCaseNumbers: () => dispatch(caseNumbers()),
    };
}

const PaymentCreateScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(PaymentCreate);

export default PaymentCreateScreen;
